/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sl_Lot_GradeInputs */

const vi_sl_lot_grade = /** @type {(inputs: Sl_Lot_GradeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phân loại`)
};

/**

* @param {Sl_Lot_GradeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sl_lot_grade = /** @type {((inputs?: Sl_Lot_GradeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sl_Lot_GradeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sl_lot_grade(inputs)
});